export default "__VITE_ASSET__ed7cd8b8__"